import { createSlice } from '@reduxjs/toolkit';
import { getMyOrders } from '../../actions/orders/myOrdersActions';
import { cancelStepChangeStatusAllOrders } from '../../actions/workQueue/allOrdersActions';

const initialState = {
  data: [],
  pagination: {},
  isLoading: false,
  hasMore: false,
};

const myOrdersReducer = createSlice({
  name: 'myOrders',
  initialState,
  extraReducers: {
    [getMyOrders.pending]: (state, { meta: { arg } }) => {
      state.isLoading = true;
      arg.pageNumber === 1 && (() => (state.data = []))();
    },
    [getMyOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.data = [
        ...(payload.pagination.pageNumber === 1 ? [] : state.data),
        ...payload.orders,
      ];
      state.pagination = payload.pagination;
      state.hasMore =
        payload.pagination.pageNumber < payload.pagination.totalPages;
    },
    [cancelStepChangeStatusAllOrders.fulfilled]: (state, { payload }) => {
      const data = [...state.data];
      const orderIndex = data.findIndex(
        o => o.orderId === payload.data.orderId
      );
      data[orderIndex] = payload.data;
      state.data = data;
    },
  },
});

export default myOrdersReducer;
